// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { useSelector } from 'react-redux';
import menuItemsManager from '../../../../menu-items/menuItemsManager';

// ==============================|| SIDEBAR MENU LIST ||============================== //

export default function MenuList() {
    const customization = useSelector((state) => state.customization);
    const navItems = menuItem.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    const navItemsManager = menuItemsManager.items.map((item) => {
        switch (item.type) {
            case 'group':
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                        Menu Items Error
                    </Typography>
                );
        }
    });

    if (customization.userData.roles[0].systemName === 'SUPER_USER') {
        return <>{navItems}</>;
    } else if (customization.userData.roles[0].systemName === 'MANAGER') {
        return <>{navItemsManager}</>;
    }
}
